const Feature = ({ id, kicker, title, body, cta, onClick, testId }) => (
  <article id={id} className="feature reveal" aria-labelledby={`${testId}-title`}>
    <div>
      <p className="kicker">{kicker}</p>
      <h3 id={`${testId}-title`}>{title}</h3>
      <p>{body}</p>
    </div>
    <a href="#contact" className="btn btn-line" onClick={onClick} data-testid={testId}>{cta}</a>
  </article>
);

export const CareersSection = ({ c, onCta }) => (
  <section id="careers" aria-label="Careers and investors" data-track-section="careers" data-nexus-s=".66" data-nexus-dim=".36" className="section">
    <div className="wrap">
      <div className="split">
        <Feature kicker={c.careers_kicker} title={c.careers_title} body={c.careers_body} cta={c.careers_cta}
          onClick={() => onCta("careers-apply", "Careers")} testId="careers-apply-cta" />
        <Feature id="investors" kicker={c.investors_kicker} title={c.investors_title} body={c.investors_body} cta={c.investors_cta}
          onClick={() => onCta("investors-enquiry", "Partnership")} testId="investors-enquiry-cta" />
      </div>
    </div>
  </section>
);
